<div class="align-items-center gap-2 rounded-4 d-flex">
  @if (deal()) {
    <span
      role="button"
      [routerLink]="'/sales/aps'"
      [ngbTooltip]="'Back to APS List'"
      placement="bottom"
      [queryParams]="{ addendum: null, option: null }"
      queryParamsHandling="merge"
      class="text-white cursor-pointer align-items-center flex-40 bg-secondary d-inline-flex fs-24 justify-content-center wh-40 rounded-circle"
    >
      <i class="bi bi-chevron-left d-inline-flex align-items-center justify-content-center"></i>
    </span>
    <div class="d-flex flex-column flex-fill overflow-hidden">
      <!-- <name-initials size="large" [data]="deal()!.prospect.firstName + ' ' + deal()!.prospect.lastName"></name-initials> -->
      <div class="d-flex align-items-center gap-3">
        <h2 class="mb-0 overflow-hidden text-nowrap text-truncate w-auto">
          {{ deal()!.prospect.name }}
        </h2>
        <i
          class="bi bi-pencil-square lh-1 text-primary cursor-pointer"
          [ngbTooltip]="'Edit Prospect'"
          (click)="editProspect()"
        ></i>

        <a class="d-md-none cursor-pointer" (click)="openProspectDialog()">
          <i class="pi pi-info-circle text-body-xs"></i>
        </a>

        <p-buttongroup class="lot-nav d-none d-md-flex" role="group" aria-label="Lot navigation">
          <p-button
            label="Prev Lot"
            icon="bi bi-chevron-left"
            iconPos="left"
            size="small"
            severity="secondary"
            [disabled]="!previousLot()"
            [ngbTooltip]="previousLot()?.lotNo ?? ''"
            container="body"
            placement="bottom"
            [ariaLabel]="previousLot() ? 'Previous lot: ' + previousLot()!.lotNo : 'No previous lot'"
            (onClick)="goToLot(previousLot()?.dealId)"
          />
          <p-button
            label="Next Lot"
            icon="bi bi-chevron-right"
            iconPos="right"
            size="small"
            severity="secondary"
            [disabled]="!nextLot()"
            [ngbTooltip]="nextLot()?.lotNo ?? ''"
            container="body"
            placement="bottom"
            [ariaLabel]="nextLot() ? 'Next lot: ' + nextLot()!.lotNo : 'No next lot'"
            (onClick)="goToLot(nextLot()?.dealId)"
          />
        </p-buttongroup>
      </div>
      <div class="d-none d-md-flex align-items-center fs-14 lh-sm">
        <!-- <div class="d-flex align-items-center gap-2"> -->

        <!-- </div> -->
        @if (deal()!.prospect.email) {
          <a class="d-flex align-items-center gap-1 gap-lg-2 text-muted" [href]="'mailto:' + deal()!.prospect.email">
            <span>{{ deal()!.prospect.email }}</span>
          </a>
        }

        @if (deal()!.prospect.phoneNumber) {
          @if (deal()!.prospect.email) {
            <span class="text-muted fs-12 mx-2">|</span>
          }
          <a class="d-flex align-items-center gap-1 gap-lg-2 text-muted" [href]="'tel:' + deal()!.prospect.phoneNumber">
            <span>{{ deal()!.prospect.phoneNumber }}</span>
          </a>
        }

        @if (prospectFrontDocumentUrl()) {
          @if (deal()!.prospect.email || deal()!.prospect.phoneNumber) {
            <span class="text-muted fs-12 mx-2">|</span>
          }
          <a class="d-flex align-items-center gap-1 gap-lg-2 text-muted" role="button" (click)="openLicensePreview()">
            <span>License</span>
          </a>
        }

        @if (deal()!.lot.lotNo) {
          @if (deal()!.prospect.email || deal()!.prospect.phoneNumber || prospectFrontDocumentUrl()) {
            <span class="text-muted fs-12 mx-2">|</span>
          }
          <a class="whitespace-nowrap text-muted">Lot: {{ deal()!.lot!.lotNo }}</a>
        }
        @if (deal()!.model || deal()!.elevation) {
          @if (
            deal()!.prospect.email || deal()!.prospect.phoneNumber || prospectFrontDocumentUrl() || deal()!.lot.lotNo
          ) {
            <span class="text-muted fs-12 mx-2">|</span>
          }
          <a class="whitespace-nowrap text-muted"
            >Model/Elevation: {{ deal()!.model?.modelName }}/{{ deal()!.elevation?.elevationCode }}</a
          >
        }
      </div>
    </div>

    <lib-deal-presence-chip />
  } @else {
    <h2 class="mb-0">Loading...</h2>
  }
  <!-- @if (deal()?.dealStatus?.name === 'Under Contract') {
  <button class="btn btn-danger d-inline-flex align-items-center gap-2 ms-auto btn-h42" (click)="handleCancelDeal()">
    <span>Cancel Deal</span>
  </button>
  } -->
</div>

<ng-template #licensePreviewModal let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header pt-3 pb-0">
      <h2 class="modal-title">License</h2>
      <span (click)="modal.dismiss()" role="button" class="ms-auto">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>
    <div class="modal-body modal-body-fixed overflow-y-auto d-flex justify-content-center align-items-center bg-light">
      @if (prospectFrontDocumentUrl()) {
        <img [src]="prospectFrontDocumentUrl()" class="object-fit-contain w-100 h-auto" alt="License" />
      } @else {
        <p class="text-muted mb-0">No license image available.</p>
      }
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-shadow" (click)="modal.dismiss('Close')">Close</button>
    </div>
  </div>
</ng-template>

<ng-template #editProspectModal let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header pt-3 pb-0">
      <h2 class="modal-title">Edit Prospect</h2>
      <span (click)="modal.dismiss()" role="button" class="ms-auto">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>
  </div>
  <div class="modal-body modal-body-fixed overflow-y-auto">
    <prospect-form
      [selectedProspectInput]="deal() ? deal()!.prospect.id : null"
      [onSubmit]="onSubmit$"
      (reload)="closeModal()"
      [enableCardScan]="false"
    ></prospect-form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close')">Close</button>
    <button type="button" class="btn btn-primary" (click)="onSubmitSubject.next()">Submit</button>
  </div>
</ng-template>

<ng-template #openProspectModal let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header pt-3 pb-0">
      <h2 class="modal-title">Prospect Details</h2>
      <span (click)="modal.dismiss()" role="button" class="ms-auto">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>
  </div>
  <div class="modal-body modal-body-fixed overflow-y-auto">
    <div class="d-flex flex-column gap-3">
      <div class="rounded-3 bg-light p-3">
        <div class="d-flex flex-column gap-2 text-muted">
          <span>Email: {{ deal()!.prospect.email || '-' }}</span>
          <span>Phone: {{ deal()!.prospect.phoneNumber || '-' }}</span>
          <span>Lot: {{ deal()!.lot.lotNo || '-' }}</span>
          <span
            >Model/Elevation: {{ deal()!.model?.modelName || '-' }}/{{ deal()!.elevation?.elevationCode || '-' }}</span
          >
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-center rounded-3 border bg-light p-3">
        @if (prospectFrontDocumentUrl()) {
          <img [src]="prospectFrontDocumentUrl()" class="object-fit-contain w-100 h-auto" alt="License" />
        } @else {
          <p class="text-muted mb-0">No license image available.</p>
        }
      </div>
    </div>
  </div>
</ng-template>
